import { Link } from "react-router-dom";
import { Heart, Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatPrice } from "@/data/products";

export const ProductCard = ({ product, index = 0 }) => {
  const { addItem, wishlist, toggleWishlist } = useCart();
  const wished = wishlist.includes(product.id);

  return (
    <div data-testid={`product-card-${product.id}`} className="group relative">
      <Link to={`/product/${product.id}`} data-testid={`product-link-${product.id}`} className="block">
        <div className="relative overflow-hidden bg-deep aspect-[3/4]">
          <img
            src={product.images[0]}
            alt={product.name}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out-expo group-hover:scale-[1.06]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-obsidian/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          {product.tag && (
            <span
              data-testid={`product-tag-${product.id}`}
              className={`absolute top-3 left-3 text-[10px] font-semibold tracking-[0.2em] uppercase px-2.5 py-1 ${
                product.tag === "new" ? "bg-mist text-obsidian" : "bg-stone text-obsidian"
              }`}
            >
              {product.tag === "new" ? "New" : "Best Seller"}
            </span>
          )}
          <button
            data-testid={`quick-add-${product.id}`}
            onClick={(e) => {
              e.preventDefault();
              addItem(product, product.sizes[Math.min(2, product.sizes.length - 1)], product.colors[0].name);
            }}
            className="absolute bottom-0 inset-x-0 bg-stone text-obsidian font-display uppercase tracking-[0.18em] text-xs py-3.5 flex items-center justify-center gap-2 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out-expo hover:bg-mist"
            aria-label={`Quick add ${product.name}`}
          >
            <Plus size={14} /> Quick Add
          </button>
        </div>
      </Link>
      <button
        data-testid={`wishlist-${product.id}`}
        onClick={() => toggleWishlist(product.id)}
        aria-label={`${wished ? "Remove from" : "Add to"} wishlist`}
        className="absolute top-3 right-3 p-1.5 text-stone/80 hover:text-stone transition-colors"
      >
        <Heart size={18} strokeWidth={1.6} className={wished ? "fill-mist text-mist" : ""} />
      </button>
      <div className="pt-4 flex items-start justify-between gap-3">
        <div>
          <Link to={`/product/${product.id}`} className="font-display uppercase tracking-wide text-[15px] hover:text-mist transition-colors">
            {product.name}
          </Link>
          <div className="flex gap-1.5 mt-2">
            {product.colors.map((c) => (
              <span
                key={c.name}
                title={c.name}
                className="h-3 w-3 rounded-full border border-stone/30"
                style={{ backgroundColor: c.hex }}
              />
            ))}
          </div>
        </div>
        <p className="text-sm text-mist whitespace-nowrap pt-0.5">{formatPrice(product.price)}</p>
      </div>
    </div>
  );
};
